import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextInput from './TextInput';

const ComboBoxInput = props => {
  const {
    id,
    options,
    TextInputProps = {},
    className = '',
    textInputClass = '',
    InputPropsClasses = {},
    ...rest
  } = props;

  const {
    inputProps = {},
    InputProps = {},
    ...OtherTextInputProps
  } = TextInputProps;

  return (
    <Autocomplete
      freeSolo
      disableClearable
      className={className}
      id={id}
      options={options}
      ListboxProps={{
        style: { maxHeight: 165 }
      }}
      renderInput={params => (
        <TextInput
          className={textInputClass}
          {...params}
          {...OtherTextInputProps}
          InputProps={{
            inputProps: {
              ...params.inputProps,
              ...inputProps,
              form: {
                autocomplete: 'off'
              }
            },
            ...params.InputProps,
            ...InputProps
          }}
          InputPropsClasses={InputPropsClasses}
        />
      )}
      {...rest}
    />
  );
};

export default ComboBoxInput;
